import React, { useState, useEffect, memo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import classNames from 'classnames';

import RaisedButton from 'material-ui/RaisedButton';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import { banUserById, unbanUserById } from 'actions/users';

import styles from 'styles';

import { approveUser, disapproveUser } from '../../../services/companies';

const SESSION_LIMIT_PLATFORMS = [
    { field: 'web', label: 'Web' },
    { field: 'iphone', label: 'iPhone' },
    { field: 'android', label: 'Android' },
    { field: 'mobile', label: 'Mobile' },
];

function formatSessionLimit(value) {
    return value === -1 ? '∞' : String(value);
}

const Row = ({
    item,
    banUserById,
    unbanUserById,
    companyRoleMode,
    isApproved,
    isFilteredByCompany,
    companyRole: propsCompanyRole,
    updateCompanyMemberStatus,
    toggleCompanyRole,
}) => {
    const [companyRole, setCompanyRole] = useState(propsCompanyRole);

    useEffect(() => {
        setCompanyRole(propsCompanyRole);
    }, [propsCompanyRole]);

    const setRoleBgColor = (role) => {
        if (role === 'manager') return 'rgb(50, 168, 82)';
        if (role === 'owner') return 'rgb(245, 188, 66)';
        if (role === 'pending' || role === 'unset') return 'rgb(135, 66, 245)';
    };
  
    const toggleCompanyMemberStatus = async () => {
        const member = item;

        if (isApproved || (item.user && item.user.approved)) {
            await disapproveUser(member);
            updateCompanyMemberStatus(member);
            return;
        }

        await approveUser(member);
        updateCompanyMemberStatus(member);
    };

    const isVerifiedEmail = item.user ? item.user.emailVerified : item.emailVerified;
    const emailStatusClass = classNames({
        'verify-email-success': isVerifiedEmail,
        'verify-email-failure': !isVerifiedEmail,
    });

    const limit = item.sessionsLimit || { total: -1 };
    const platformsPresent = SESSION_LIMIT_PLATFORMS.filter(({ field }) => limit[field] !== undefined);
    const platformSummary = platformsPresent
        .map(({ field, label }) => `${label} ${formatSessionLimit(limit[field])}`)
        .join(' · ');
    const sessionLimitsTitle = platformSummary
        ? `Total ${formatSessionLimit(limit.total)} — ${platformSummary}. Edit limits.`
        : `Total ${formatSessionLimit(limit.total)}. Edit limits.`;

    return (
        <TableRow>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                {item.name || (item.user && item.user.name)}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnBigCSS}>
                <Link
                    to={`/users/${(item.user && item.user._id) || item._id}`}
                    className='common-link'
                    target='_blank'
                >
                    {item.email || (item.user && item.user.email)}
                </Link>
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                {item.role}
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                {isFilteredByCompany ? 
                    new Date(item.user && item.user.createdAt).toLocaleDateString() : 
                    new Date(item.createdAt).toLocaleDateString()
                }
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                {item.company && item.company.name}
            </TableRowColumn>
            {companyRoleMode && isFilteredByCompany ? 
                <TableRowColumn>
                    <RaisedButton 
                        label={companyRole}
                        labelColor="#fff"
                        backgroundColor={setRoleBgColor(companyRole)}
                        onClick={() => toggleCompanyRole(item)}
                    />
                </TableRowColumn> : 
                null
            }
            <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                <div className={emailStatusClass}> {`${isVerifiedEmail ? '' : 'not '} verified`}</div>
            </TableRowColumn> 
            <TableRowColumn style={{ ...styles.tableHeaderColumnSmallCSS, textAlign: 'center', padding: '0' }}>
                <RaisedButton 
                    backgroundColor={isApproved ? 'rgb(250, 76, 52)' : 'rgb(164, 198, 57)'}
                    label={isApproved ? 'Disapprove' : 'Approve'}
                    labelColor="#fff"
                    onClick={toggleCompanyMemberStatus}
                    disabled={!isFilteredByCompany}
                />
            </TableRowColumn> 
            <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                <Link
                    to={`/users/${(item.user && item.user._id) || item._id}?panel=SessionLimits`}
                    className='common-link'
                    target='_blank'
                    title={sessionLimitsTitle}
                    style={{ display: 'block', textAlign: 'center', padding: '2px 0' }}
                >
                    <span
                        style={{
                            display: 'block',
                            fontSize: 13,
                            fontWeight: 600,
                            fontVariantNumeric: 'tabular-nums',
                            lineHeight: 1.2,
                        }}
                    >
                        Total {formatSessionLimit(limit.total)}
                    </span>
                    {platformSummary ? (
                        <span
                            style={{
                                display: 'block',
                                marginTop: 2,
                                fontSize: 10,
                                lineHeight: 1.35,
                                color: '#9E9E9E',
                                fontWeight: 400,
                            }}
                        >
                            {platformSummary}
                        </span>
                    ) : null}
                </Link>
            </TableRowColumn>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                {
                    !item.banAt
                        ? <RaisedButton
                            label='ban'
                            onClick={() => {
                                banUserById(item);
                            }}
                            secondary
                        /> :
                        <RaisedButton
                            label='unban'
                            onClick={() => {
                                unbanUserById(item);
                            }}
                            primary
                        />
                }
            </TableRowColumn>
        </TableRow>
    );
};

export default connect(
    (state, { item }) => ({
        item,
    }),
    dispatch => bindActionCreators({
        banUserById,
        unbanUserById,
    }, dispatch),
)(memo(Row));



// WEBPACK FOOTER //
// ./app/components/Users/BanList/Row.jsx